import {SelectorType} from '@Components/poster-editor/components/poster-seekbar/components/change-duration-selector/change-duration-selector.types';

export const getSelectorTypeOnOpen = (): SelectorType => {
  const page = window.posterEditor?.whiteboard?.getCurrentPage();
  const currentPageDuration = window.posterEditor?.whiteboard?.getCurrentPage().getDuration();

  if (page?.items.getLongestVideoItemDuration() === currentPageDuration) {
    return SelectorType.VIDEO;
  }

  if (page?.items.getLongestSlideshowItemDuration() === currentPageDuration) {
    return SelectorType.SLIDESHOW;
  }

  if (window.posterEditor?.whiteboard?.audioClips.getDuration() === currentPageDuration) {
    return SelectorType.AUDIO;
  }

  return SelectorType.CUSTOM;
};
